import React from "react";
import contentfulGuideApp, {
	fetchProps,
} from "@insightfulscience/contentful/Apps/Guides";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import SectionTryForFree from "@src/SectionTryForFree";
import { contentfulProps } from "@src/config";
import resources from "../../locales/guides-page";

const guideLayout = ({ children }) => {
	const [t] = useLocale("guides");

	return (
		<SiteLayout hero>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContentfulGuideApp = contentfulGuideApp({
	Layout: pipe(guideLayout, WithLocale({ resources })),
	contentfulProps,
	pageProps: {
		brandCode: "sg",
		siteDomain: "https://www.snapgene.com",
		breadcrumbs: [
			{
				title: "Home",
				href: "/",
			},
			{
				title: "Resources",
				href: "/resources",
			},
		],
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, "sg", false);

	return props?.post
		? {
				props,
				revalidate: false,
			}
		: { notFound: true };
};

export default ContentfulGuideApp;
